<template>
  <div>
    <check-authorization :requiresAuthorizations="['listar usuarios']">
      <div class="card card-header-actions mb-4">
        <b-card-header>
          Usuarios

          <div class="ml-auto d-flex justify-content-end align-items-center flex-wrap">
            <!-- Form -->
            <check-authorization
              :requiresAuthorizations="['crear usuarios']"
              :overrideIf="$store.getters['userModule/isEditingUser']"
            >
              <user-form
                :value="showForm || isEditingUser"
                @input="showForm = $event"
              />
            </check-authorization>
            <!-- Options -->
            <div class="dropdown no-caret">
              <button
                class="btn btn-transparent-dark btn-icon dropdown-toggle"
                type="button"
                data-toggle="dropdown"
              >
                <i data-feather="more-vertical"></i>
              </button>
              <div class="dropdown-menu dropdown-menu-right animated--fade-in-up">
                <a class="dropdown-item my-cursor" @click="getUsers(null)">
                  Recargar
                </a>
              </div>
            </div>
          </div>
        </b-card-header>

        <b-card-body class="p-2">
          <!-- Filtro y búsqueda arriba de la tabla; en el encabezado no caben en una línea -->
          <div class="d-flex flex-wrap align-items-center mb-2 users-toolbar">
            <b-form-radio-group
              :checked="estado"
              :options="estados"
              buttons
              button-variant="outline-primary"
              size="sm"
              class="users-filter"
              @change="changeEstado"
            />
            <user-search class="ml-auto"></user-search>
          </div>
          <user-list @on-got-item="showForm = true"></user-list>
        </b-card-body>
      </div>
    </check-authorization>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import UserForm from '@/components/Users/UserForm'
import UserList from '@/components/Users/UserList'
import UserSearch from '@/components/Users/UserSearch'

export default {
  name: 'Users',

  components: {
    UserForm,
    UserList,
    UserSearch
  },

  data () {
    return {
      hideButton: false,
      showForm: false,
      estados: [
        { text: 'Todos', value: 'todos' },
        { text: 'Habilitados', value: 'activos' },
        { text: 'Deshabilitados', value: 'deshabilitados' }
      ]
    }
  },

  computed: {
    ...mapGetters('userModule', ['isEditingUser']),

    estado () {
      return this.$store.state.userModule.estado || 'todos'
    }
  },

  methods: {
    ...mapActions('userModule', ['getUsers', 'changeEstado'])
  }
}
</script>

<style lang="scss" scoped>
.users-filter ::v-deep .btn {
  white-space: nowrap;
}

.users-toolbar {
  gap: 0.5rem;
}
</style>
